import * as React from 'react';
import * as ContractRepository from '../../../Repository/ContractRepository';
// import _ from "lodash";
// import { Tag } from "antd";
import { UserRoles } from '../../../Repository/UserRepository';
import { formatUTCDateFromDateString } from "../../../Helper/DateHelper";
import { Contract, Tree, ContractUser, User } from 'tree-wallet-client';
// import { getValidatedTrees } from '../../../Service/TreeService';
import { isAllowed } from '../../../Service/AuthService';
import ValidationTable from '../../../Component/ValidationTable/ValidationTable';

interface TreeDescriptionProps {
  tree: Tree;
  user: User;
  language: string;
  contract?: Contract;
  isValidated: boolean;
}

const containerStyle = {
  padding: '5px 0px',
}

const labelStyle = {
  fontWeight: 'bold',
  marginRight: '10px'
};

const contentStyle = {};

function getTranslation(tree: Tree, language: string) {
  try {
    return tree.treeType.translations[language]
      ? tree.treeType.translations[language]
      : tree.treeType.translations.latin;
  } catch (err) {
    return tree.treeType.translations.latin;
  }
}

export default function TreeDescription(props: TreeDescriptionProps) {
  const { tree, language, isValidated, contract, user } = props;
  const translation = getTranslation(tree, language);
  const latinTranslation = getTranslation(tree, 'latin');

  const getCustomer = () => {
    const customers = contract?.contractUsers?.filter((cu: any) => {
      return cu.roles.indexOf(ContractRepository.roles.Customer.name) > -1;
    });

    if (customers && customers.length >= 1) {
      return customers;
    }

    return undefined;
  };

  const calculateCo2Compensation = (plantingDate: string) => {
    const plantingDateObj = new Date(plantingDate);
    const nowDateObj = new Date();
    const timeDiff = nowDateObj.getTime() - plantingDateObj.getTime();
    const daysDiff = (timeDiff / 3600) / 24;
    const co2Compensation = (daysDiff / 365.25) * 22;
    return parseFloat((co2Compensation / 1000).toFixed(2));
  };

  // const getValidationLabel = (tree: Tree) => {
  //   if (!isValidated) {
  //     //   return <Tag icon={<ExclamationCircleOutlined/>} color="red">TO BE VALIDATED</Tag>
  //     // } else
  //     if (_.findIndex(getValidatedTrees(), { 'id': String(tree.id) }) > -1) {
  //       return <Tag color="orange">QUEUED</Tag>
  //     } else {
  //       return <Tag color="green">{tree.validationHash ? tree.validationHash : "VALIDATED"}</Tag>
  //     }
  //   }
  // };

  const customers = getCustomer();
  const timeDate = formatUTCDateFromDateString(tree.createdAt);

  return <>
    <div style={containerStyle}>
      <span style={labelStyle}>ID</span>
      <span style={contentStyle}>{tree.id}</span>
    </div>
    <div style={containerStyle}>
      <div style={labelStyle}>Description</div>
      <div style={contentStyle}>
        {`${tree.numberPlanted}x ${translation}`}
        <span style={{ display: latinTranslation === translation ? 'none' : 'inline', marginLeft: '5px' }}>({latinTranslation})</span>
      </div>
    </div>
    <div style={containerStyle}>
      <div style={labelStyle}>Type</div>
      <div style={contentStyle}>{tree.treeType?.fruitTree ? 'fruit tree' : 'shade tree'}</div>
    </div>
    <div style={containerStyle}>
      <div style={labelStyle}>Position accuracy</div>
      <div style={contentStyle}>{`${tree.accuracy}`} meter{Math.floor(tree.accuracy) > 1 ? 's' : ''}</div>
    </div>
    <div style={containerStyle}>
      <div style={labelStyle}>Altitude</div>
      <div style={contentStyle}>{tree.altitude === 0 ? '-' : `${Math.round(tree.altitude)} meter${Math.abs(Math.round(tree.altitude)) > 1 ? 's' : ''}`}</div>
    </div>
    {tree.altitude_accuracy !== undefined && tree.altitude_accuracy !== null && (
      <div style={containerStyle}>
        <div style={labelStyle}>Altitude accuracy</div>
        <div style={contentStyle}>{`${Math.floor(tree.altitude_accuracy)} meter${Math.abs(Math.floor(tree.altitude_accuracy)) > 1 ? 's' : ''}`}</div>
      </div>
    )}
    {isAllowed(user.roles, [UserRoles.Admin]) &&
      <div style={containerStyle}>
        <div style={labelStyle}>Contract</div>
        <div style={contentStyle}>{`${tree.contract?.description} (ID ${tree.contract?.id})`}</div>
      </div>
    }
    <div style={containerStyle}>
      <div style={labelStyle}>Planted by</div>
      <div style={contentStyle}>{`${tree.user.firstName} ${tree.user.lastName}`}</div>
    </div>
    <div style={containerStyle}>
      <div style={labelStyle}>Date</div>
      <div style={contentStyle}>
        {timeDate.date} {timeDate.time} (UTC)
      </div>
    </div>
    {tree.plantedHash &&
      <div style={containerStyle}>
        <div style={labelStyle}>Planting hash</div>
        <div style={contentStyle}>{tree.plantedHash}</div>
      </div>
    }
    {isValidated &&
      <div style={containerStyle}>
        <div style={labelStyle}>Stored CO2</div>
        <div style={contentStyle}>
          {calculateCo2Compensation(tree.createdAt)} Kg
        </div>
      </div>
    }
    {customers &&
      <div style={containerStyle}>
        <div style={labelStyle}>Sponsored by</div>
        <div style={contentStyle}>
          {
            customers.map((customer: ContractUser) => {
              return (
                <div key={'tree_customer'}>
                  {customer?.user?.company
                    ? customer?.user?.company
                    : `${customer?.user?.firstName} ${customer?.user?.lastName}`}
                </div>
              )
            })
          }
        </div>
      </div>
    }
    {tree.treeValidations && tree.treeValidations.length > 0 &&
      <ValidationTable
        tree={tree}
      />
    }
  </>
}
